import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
var _context;
import React, { useContext } from 'react';
import cx from 'classnames';
import keys from "lodash/keys";
import { uniqueInnerId } from '@jutro/platform';
import { TranslatorContext } from '@jutro/locale';
//Repointed to use Saga styles
//import styles from "./CubeLoader.module.css";
import styles from "saga-styling/common-styles/widgets/CubeLoader.module.css";
import { messages } from './CubeLoader.messages';
export function CubeLoader() {
  var translator = useContext(TranslatorContext);
  var _uniqueInnerId = uniqueInnerId('CubeLoader', 'labelId'),
    labelId = _uniqueInnerId.labelId;

  //Changed by Saga to return an extra containing DIV as an opaque background
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: styles.loaderBackgroundContainer
  }), React.createElement("div", {
    className: styles.cubeLoader,
    "aria-labelledby": labelId
  }), React.createElement("div", {
    id: labelId,
    className: styles.screenReaderOnly
  }, translator(messages.loading)));
}
CubeLoader.__docgenInfo = {
  componentName: "CubeLoader",
  packageName: "@jutro/components",
  description: "CubeLoader is default loader element for Loader component",
  displayName: "CubeLoader",
  methods: [],
  actualName: "CubeLoader"
};